var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "150%",
    height: "150%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15417",
    "data-name": "Grupo 15417",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11399",
    "data-name": "Trazado 11399",
    d: "M11.532,18.771a1.189,1.189,0,0,0,.962-.485l7.346-9.9L18.723,7.56l-7.23,9.756L7.566,14.444,6.75,15.56l4.081,2.987a1.193,1.193,0,0,0,.7.231",
    transform: "translate(-1.553 -1.739)",
    fill: "#03ac63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11400",
    "data-name": "Trazado 11400",
    d: "M20.489,3.511A12.005,12.005,0,0,0,3.511,20.489c.177.177.354.339.531.5L5.028,20c-.185-.162-.362-.323-.539-.5a10.6,10.6,0,1,1,1.732,1.409l-1,1a12.008,12.008,0,0,0,15.269-18.4",
    fill: "#03ac63"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.25a55e4a019de33d5c712656ffc407e7.svg";
export { ForwardRef as ReactComponent };